import { forwardRef } from "react";
import Turnstile from "react-turnstile";

const TurnstileRecaptcha = forwardRef(({ onChange, onLoad, onError }, ref) => {
  return (
    <Turnstile
      sitekey="0x4AAAAAAB4oNCgfHXyJLs0P"
      refreshExpired={"auto"}
      fixedSize={true}
      onVerify={(token) => {
        onChange(token);
      }}
      onError={onError}
    />
  );
});

export default TurnstileRecaptcha;
